import { ref, Ref } from 'vue';

/**
 * A composable function to manage modal state.
 *
 * @param [defaultValue=false] - The initial state of the modal (opened or closed).
 * @returns A tuple containing:
 *   - isModalOpen: A reactive reference to the modal's open state.
 *   - openModal: A function to open the modal.
 *   - closeModal: A function to close the modal.
 */
export const useModal = (defaultValue = false): [Ref<boolean>, () => void, () => void] => {
  const isModalOpen = ref(defaultValue);

  const openModal = () => {
    isModalOpen.value = true;
  };

  const closeModal = () => {
    isModalOpen.value = false;
  };

  return [
    isModalOpen,
    openModal,
    closeModal,
  ];
};
